export function getPlatformsString(platforms) {
  return platforms.map((platform) => platform.name).join(', ');
}
